import useUsers from 'src/admin/users/hooks/useUsers';

export const useAdvisors = (enabled = true) => {
  const { users, isLoading, refetch } = useUsers(
    ['ADVISOR', 'SYSTEM_ADMIN', 'SERVICE_ADMIN'],
    !enabled,
  );

  return {
    advisors: users,
    isLoading,
    refetch,
  };
};
